import { RootState } from '../store';

export const selectDepartments = (state: RootState) => state.departments.departmentsData;
export const selectDepartmentsLoaded = (state: RootState) => state.departments.loaded;
export const selectDepartmentsError = (state: RootState) => state.departments.error;
